function isMobile() {
  const reg =
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  let mobile = navigator.userAgent.match(reg) || window.innerWidth < 768;
  console.log("mobile", mobile, navigator.userAgent);
  return mobile;
}
export { isMobile };
